export default class CardAdvertising {
    
    static get selector() {
        return '.cardAdvertising';
    }

    constructor(el) {
        this.el = el;
        this.link = el.querySelector('.cardAdvertising__link');
        this.ad = {
            size : this.el.dataset.size,
            id : this.el.dataset.id,
            url : this.link.href
        };
        this.isViewed = false;

        this.impresssion();

        window.dispatchEvent( new CustomEvent('vegout-pluton-update', {
            detail: {  el: this.el  }
        }));
        this.setEvents();
    }

    impresssion() {
        gtag('event', 'vgAdvertising', this.ad);
        console.log('Ad Impression',this.ad.id)

        this.sendAdAction(this.ad.id, 'impressionpage');
    }

    view() {
        if(this.isViewed) return;
        console.log('Ad View',this.ad.id);
        this.sendAdAction(this.ad.id, 'viewpage');
        this.isViewed = true;
    }

    click() {
        console.log('Ad Click',this.ad.id);
        this.sendAdAction(this.ad.id, 'clickpage')
    }

    sendAdAction( id, action) {
        const data = new FormData();
        data.append( 'action', action );
        data.append( 'postid', id);
        
        fetch(ajaxurl, {
            method: "POST",
            credentials: 'same-origin',
            body: data
        })
        .then((response) => response.json())
        .then((data) => {
            if (action == 'clickpage' ) {
                window.open(this.ad.url, '_blank');
            }
        })
        .catch((error) => {
            console.log('[adview error] : ' + action);
            console.error(error);
        });
    }

    setEvents() {
        this.el.addEventListener('inView', this.e_inview.bind(this));
        //this.link.addEventListener('click', this.e_click.bind(this));
    }

    e_inview() {
        this.view();
    }

    e_click(e) {
        e.preventDefault();
        this.click();
    }

}